<template>

    <div class="example">

        <header class="header">
            <span class="text-xlSemibold color__white">{{ $t('quit_discovery_mode') }}</span>
            <img class="img__24 pointer" src="/img/icons/arrow-right-white.svg" @click="close">
        </header>

        <div class="resume">
            <div class="infos" v-show="!isDesktop">
                <img src="/img/discovery/avatar.svg" class="img__36 mr__8">
                <span class="text-baseRegular foxy-name">{{ $t('foxys_tutorial') }}</span>
            </div>

            <div class="switch text-baseSemibold" @click="toggle">
                <div :class="{'selected': isCards}" class="mr__12 option">{{ $t('cleaning_cards') }}</div>
                <div :class="{'selected': isList}" class="option">{{ $t('cleaning_list') }}</div>
            </div>
        </div>

        <cards v-if="isCards"
               ref="CARDS"
               :subscriptions="exampleNewsletters"
               @action="removeElements"
        ></cards>

        <list v-if="isList"
              :list="exampleNewsletters"
              @action="removeElements"
        ></list>

        <bottom-sheet-discovery-connect-or-continue ref="BSDCOC"></bottom-sheet-discovery-connect-or-continue>

    </div>

</template>

<script>
import ENUM from '../../assets/ENUM'

import BottomSheetDiscoveryConnectOrContinue from '../../components/bottomSheet/BottomSheetDiscoveryConnectOrContinue'
import Cards from '../../components/newsletters-v2/Cards'
import List from '../../components/newsletters-v2/List'

import Tag from '../../modules/tag'

export default {

    name: 'newsletters-example',

    components: {
        BottomSheetDiscoveryConnectOrContinue,
        Cards,
        List
    },

    computed: {
        isCards() {
            return this.selected === ENUM.NEWSLETTERS.PAGE.CARDS
        },
        isList() {
            return this.selected === ENUM.NEWSLETTERS.PAGE.LIST
        }
    },

    watch: {
        selected(value) {
            value === ENUM.NEWSLETTERS.PAGE.CARDS
                ? Tag.pageViewAll(this, 'demo_mode_card')
                : Tag.pageViewAll(this, 'demo_mode_list')
        }
    },

    data() {
        return {
            showList: false,
            showCards: true,
            actionsCount: 0,
            selected: null,
            exampleNewsletters: [
                {
                    email: 'demo@account.com',
                    sender: 'info@softwareinfo.com',
                    name: this.$t('software_info'),
                    openRate: 10,
                    count: 89,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                },
                {
                    email: 'demo@account.com',
                    sender: 'noreply@jobalert.com',
                    name: this.$t('job_alert'),
                    openRate: 5,
                    count: 123,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                },
                {
                    email: 'demo@account.com',
                    sender: 'info@theplantstore.com',
                    name: this.$t('the_plant_store'),
                    openRate: 17,
                    count: 130,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                },
                {
                    email: 'demo@account.com',
                    sender: 'news@videogames.com',
                    name: this.$t('video_game_store'),
                    openRate: 12,
                    count: 180,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                },
                {
                    email: 'demo@account.com',
                    sender: 'noreply@daycarecenter.com',
                    name: this.$t('daycare_center'),
                    openRate: 67,
                    count: 213,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                },
                {
                    email: 'demo@account.com',
                    sender: 'noreply@charity.com',
                    name: this.$t('charity'),
                    openRate: 25,
                    count: 30,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                },
                {
                    email: 'demo@account.com',
                    sender: 'news@yourcity.com',
                    name: this.$t('current_event_your_city'),
                    openRate: 24,
                    count: 289,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                },
                {
                    email: 'demo@account.com',
                    sender: 'info@staff-newsletter.com',
                    name: this.$t('staff_newsletter'),
                    openRate: 32,
                    count: 15,
                    invalidGrant: false,
                    spoumConfidence: 0,
                    incrementalComputed: false,
                    lastReceivedAt: '2024-11-17T03:24:12.000Z',
                    type: ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS
                }
            ]

        }
    },

    mounted() {
        this.selected = ENUM.NEWSLETTERS.PAGE.CARDS
    },

    methods: {
        toggle() {
            this.selected = this.isCards
                ? ENUM.NEWSLETTERS.PAGE.LIST
                : ENUM.NEWSLETTERS.PAGE.CARDS
        },

        removeElements({enumAction, senders}) {

            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    this.clickEvent('delete')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    this.clickEvent('autodelete')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    this.clickEvent('keep')
                    break
            }

            const toRemove = senders.map(sender => sender.sender)
            this.exampleNewsletters = this.exampleNewsletters.filter(newsletter => !toRemove.includes(newsletter.sender))



            if(this.exampleNewsletters.length === 0) {
                this.$emit('ended')
            } else {
                this.actionsCount++

                if(this.actionsCount === 2) {
                    this.$refs.BSDCOC.open()
                }
            }
        },

        clickEvent(name) {
            Tag.clickAll(this, name, null, this.isCards ? 'demo_mode_card' : 'demo_mode_list')
        },

        close() {
            this.clickEvent('exit')
            this.$emit('close')
        }
    }

}
</script>

<style lang="scss" scoped>

.example {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: $timberwolf;

    .header {
        padding: 12px 16px;
        background: linear-gradient(90deg, #0089E7 0%, #00C09B 100%);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .resume {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        background-color: $timberwolf;
        box-shadow: 0px 0.5px 0px 0px rgba(0, 0, 0, 0.12);
        @media screen and (min-width: $above-tablet-length) {
            justify-content: center;
        }


        .infos {
            display: flex;
            flex-direction: row;
            align-items: center;

            .foxy-name {
                width: min-content;
                text-align: start;
            }
        }

        .switch {
            cursor: pointer;
            background-color: $blue;
            color: $white;
            padding: 2px;
            border-radius: 32px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .option {
                padding: 12px;
                border-radius: 28px;
            }

            .selected {
                background-color: $white;
                color: $charcoal;
            }
        }
    }
}

</style>
